module.exports = __webpack_public_path__ + "static/media/AB_ZW10_2.ac27ee44.jpg";